import React from "react";
import PropTypes from "prop-types";
import Box from "../wrappers/Box";
import Divider from "../wrappers/Divider";
import Stack from "../wrappers/Stack";
import Typography from "../wrappers/Typography";
import {
  SearchFiltersSectionsProvider,
  SearchFiltersSectionsToggle,
} from "./SearchFiltersSectionsContext";

/**
 * Organiza o painel lateral de filtros com cabeçalho e ações fixas.
 *
 * @param {object} pProps Propriedades do componente.
 * @param {string} pProps.title Título apresentado no cabeçalho.
 * @param {React.ReactNode} [pProps.description] Descrição complementar.
 * @param {React.ReactNode} pProps.children Conteúdo rolável dos filtros.
 * @param {React.ReactNode} pProps.actions Ações apresentadas fora do corpo.
 * @returns {React.ReactElement}
 */
const SearchFiltersSidebarContent = (pProps) => {
  const { title, description, children, actions } = pProps;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        height: "100%",
      }}
    >
      <Box
        data-search-filters-sidebar-header
        sx={{ flexShrink: 0, px: 2, pb: 1.5, pt: 3 }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography component="h6" variant="body1" sx={{ fontWeight: 500 }}>
            {title}
          </Typography>
          <SearchFiltersSectionsToggle />
        </Stack>
        {description ? (
          <Typography color="text.secondary" variant="body2">
            {description}
          </Typography>
        ) : null}
      </Box>
      <Divider />
      <Box
        data-search-filters-sidebar-body
        sx={{ flex: 1, minHeight: 0, overflowY: "auto", px: 2, py: 1.5 }}
      >
        <Stack spacing={2}>{children}</Stack>
      </Box>
      <Divider />
      <Box data-search-filters-sidebar-actions sx={{ flexShrink: 0, p: 2 }}>
        {actions}
      </Box>
    </Box>
  );
};

/** Isola o estado de abertura das seções pertencentes a esta sidebar. */
const SearchFiltersSidebar = (pProps) => (
  <SearchFiltersSectionsProvider>
    <SearchFiltersSidebarContent {...pProps} />
  </SearchFiltersSectionsProvider>
);

SearchFiltersSidebar.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.node,
  children: PropTypes.node.isRequired,
  actions: PropTypes.node.isRequired,
};

export default SearchFiltersSidebar;
